import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  CircularProgress,
} from "@mui/material";
import { COLORS, FieldLabel, PrimaryButton, SecondaryButton, fieldSx } from "./wtStyle";

// Shared Review screen (FR-16 plain-language summary + reason field) for
// Move-someone's-work and Transfer-by-project. allowRoundRobin is false for
// modes where it's structurally disallowed (FR-5/FR-19).
export default function ReviewDialog({
  open,
  onClose,
  summaryLines,
  reason,
  setReason,
  distribution,
  setDistribution,
  allowRoundRobin,
  onConfirm,
  confirming,
  extraContent,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>Review transfer</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 2 }}>
          {summaryLines.map((line, i) => (
            <Typography key={i} fontSize={13.5}>
              • {line}
            </Typography>
          ))}
        </Box>

        {allowRoundRobin && (
          <Box sx={{ mb: 2 }}>
            <FieldLabel>Distribution</FieldLabel>
            <RadioGroup row value={distribution} onChange={(e) => setDistribution(e.target.value)}>
              <FormControlLabel value="single" control={<Radio size="small" />} label={<Typography fontSize={13.5}>Single recipient</Typography>} />
              <FormControlLabel value="roundrobin" control={<Radio size="small" />} label={<Typography fontSize={13.5}>Round robin</Typography>} />
            </RadioGroup>
          </Box>
        )}

        {extraContent}

        <FieldLabel>
          Reason <span style={{ color: COLORS.red }}>*</span>
        </FieldLabel>
        <TextField
          required
          multiline
          minRows={2}
          fullWidth
          placeholder="e.g. Rahul resigned, effective 09 Aug 2026"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={reason.trim().length === 0}
          helperText={reason.trim().length === 0 ? "A reason is required before this transfer can be confirmed." : " "}
          sx={fieldSx}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, bgcolor: COLORS.sunken, borderTop: `1px solid ${COLORS.border}` }}>
        <SecondaryButton onClick={onClose} disabled={confirming}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onConfirm} disabled={confirming || reason.trim().length === 0}>
          {confirming ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Confirm transfer"}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
